import { agentHueStyle } from '@/frontend/lib/agentHue'

interface Props {
  name: string
  /** Seed do hue de identidade (B.4); sem ele o mini-avatar usa o hue fallback. */
  workerId?: string | null
  className?: string
}

/**
 * Mini-avatar 20px de identidade do agente (protótipo chat-first): círculo
 * chapado na cor do agente com as iniciais — usado nos chips AO VIVO e nas
 * linhas de feed/aprovações, onde o avatar dither ficaria ilegível.
 */
export function MiniAvatar({ name, workerId, className = '' }: Props) {
  const initials = name
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

  return (
    <span
      aria-hidden
      style={workerId ? agentHueStyle(workerId) : undefined}
      className={`inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-agent text-[8px] font-bold leading-none text-agent-foreground ${className}`}
    >
      {initials}
    </span>
  )
}
